/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCourse200,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCourse401,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCourse500,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCoursePathParams,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCourseQueryParams,
  GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCourseQueryResponse,
} from "../../types/individualPaymentPaymentHistoryController/GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCourse.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCoursePathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCoursePathParams>;

export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCourseQueryParamsSchema =
  z
    .object({
      companyId: z.optional(z.coerce.number().int()),
    })
    .optional() as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCourseQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCourse200Schema =
  z.array(
    z.lazy(() => dropDownListViewModelSchema),
  ) as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCourse200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCourse401Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCourse401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCourse500Schema =
  z.any() as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCourse500>;

export const getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCourseQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCourse200Schema,
  ) as unknown as ToZod<GetApiV1IndividualpaymentCourseRegistrationsCourseregistrationidCourseFinancialsWithCourseQueryResponse>;
